import { Component, Input } from '@angular/core';
import { Amenity } from '../../models/amenity.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AmenityService } from '../../services/amenity.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-amenity-modal',
  templateUrl: './amenity-modal.component.html',
  styleUrl: './amenity-modal.component.scss'
})
export class AmenityModalComponent {

  @Input() neighborhoodId: string = '';
  @Input() amenity?: Amenity;

  public dataForm: DataFormModel = {
    image: {
      value: '',
      type: 'image',
      label: '',
      required: false,
      validators: []
    },
    name: {
      value: '',
      type: 'text',
      label: 'Nombre del área común',
      requiredMessage: 'Por favor, ingrese el nombre del área común',
      required: true,
      validators: [Validators.required]
    },
    notes: {
      value: '',
      type: 'textarea',
      label: 'Notas o reglas de uso (Opcional)',
      requiredMessage: '',
      required: false,
      validators: []
    },
    // needAPay: {
    //   value: false,
    //   type: 'switch',
    //   label: '¿Requiere pago?',
    //   requiredMessage: '',
    //   required: false,
    //   validators: []
    // },
    capacity: {
      value: '0',
      type: 'number',
      label: 'Aforo permitido',
      requiredMessage: 'Por favor, ingrese el número de aforo permitido',
      required: true,
      validators: [Validators.required]
    },
    guestsPerResident: {
      value: '0',
      type: 'number',
      label: 'Invitados máximos por residente',
      requiredMessage: 'Por favor, ingrese la cantidad de invitados',
      required: true,
      validators: [Validators.required]
    },
    bookingsPerDay: {
      value: '0',
      type: 'number',
      label: 'Reservaciones permitidas al día por residente',
      requiredMessage: 'Por favor, ingrese el número de reservaciones permitidas por día por residente',
      required: true,
      validators: [Validators.required]
    },
    anticipations: {
      value: '0',
      type: 'number',
      label: 'Ventana de reservación (En horas)',
      requiredMessage: 'Por favor, ingrese en horas la venata de reservación',
      required: true,
      validators: [Validators.required]
    },
    status: {
      value: true,
      type: 'switch',
      label: 'Activo',
      requiredMessage: '',
      required: false,
      validators: []
    },
    canBeBlocked: {
      value: true,
      type: 'switch',
      label: '¿Puede ser reservado todo el horario seleccionado?',
      requiredMessage: '',
      required: false,
      validators: []
    }
  };

  public selectedFile: File | null = null;
  public imageBase64: string | null = null;
  public selectedRegulationFile: File | null = null;

  public formAmenity!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public amenityService: AmenityService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formAmenity.controls;
  }

  /*
  ██╗      ██████╗  █████╗ ██████╗ ██████╗  █████╗ ████████╗ █████╗
  ██║     ██╔═══██╗██╔══██╗██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║     ██║   ██║███████║██║  ██║██║  ██║███████║   ██║   ███████║
  ██║     ██║   ██║██╔══██║██║  ██║██║  ██║██╔══██║   ██║   ██╔══██║
  ███████╗╚██████╔╝██║  ██║██████╔╝██████╔╝██║  ██║   ██║   ██║  ██║
  ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  async loadData() {
    this.loading = true;

    if (this.amenity) {
      this.dataForm = {
        ...this.dataForm
      };

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.amenity) {
          const standardKey = key as keyof typeof this.amenity;
          this.dataForm[key].value = this.amenity[standardKey]!;
        }
      }
    }

    this.formAmenity = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗██╗     ███████╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗
  ██╔═══██╗████╗  ██║██╔════╝██║██║     ██╔════╝██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝
  ██║   ██║██╔██╗ ██║█████╗  ██║██║     █████╗  ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗
  ██║   ██║██║╚██╗██║██╔══╝  ██║██║     ██╔══╝  ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝
  ╚██████╔╝██║ ╚████║██║     ██║███████╗███████╗╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗
   ╚═════╝ ╚═╝  ╚═══╝╚═╝     ╚═╝╚══════╝╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝

  */
  /**
   * FUNCTION onFileChange
   * 
   * @param event 
   */
  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageBase64 = reader.result as string;
      };
    }
  }

  onRegulationFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        alert('El reglamento debe ser un archivo PDF.');
        event.target.value = '';
        this.selectedRegulationFile = null;
        return;
      }
      const maxSizeBytes = 3 * 1024 * 1024; // 3 MB
      if (file.size > maxSizeBytes) {
        alert('El archivo no puede superar los 3 MB.');
        event.target.value = '';
        this.selectedRegulationFile = null;
        return;
      }
      this.selectedRegulationFile = file;
    }
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  async onSubmit() {
    this.submitted = true;

    if (this.formAmenity.invalid) {
      return;
    }

    if(
      this.formAmenity.value.guestsPerResident >= this.formAmenity.value.capacity
    ) {

      alert('El número de invitados por residente no puede ser mayor o igual al aforo permitido');
      return;

    }

    if (this.amenity) {
      await this.update();
    } else {
      await this.create();
    }
  }

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async create() {

    const flag = await this.amenityService.create(
      this.neighborhoodId,
      this.formAmenity.value,
      this.selectedFile ?? undefined,
      this.selectedRegulationFile ?? undefined
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }
      this.activeModal.close();
    }
  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update() {
    this.formAmenity.value.amenityId = this.amenity!.amenityId;
    this.formAmenity.value.neighborhoodId = this.amenity!.neighborhoodId;

    const flag = await this.amenityService.update(
      this.formAmenity.value,
      this.selectedFile ?? undefined,
      this.selectedRegulationFile ?? undefined
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }
      this.activeModal.close();
    }
  }

}
